import { render } from "./Clases2.vue?vue&type=template&id=65d419a4"
import script from "./Clases2.vue?vue&type=script&lang=js"
export * from "./Clases2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProductFactory\\analiaperez-landing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__